
///////////////////////////////////////////////////////////////////////
// GLOBAL VARIABLES AND CACHE
///////////////////////////////////////////////////////////////////////
const startfrom = 0; // slide index
window.App = window.App || {};

App.modules = App.modules || {};
App.progress = App.progress || {};
// App.progress = { value: 0 };
App.layout = App.layout || {};
App.sound = App.sound || {};
App.globalscrub = App.globalscrub || {}; // Ensure this exists to attach addons
App.RelativeMultiScrub = App.RelativeMultiScrub || {};
App.TriggeredAnimations = App.TriggeredAnimations || {};
App.InOutTimelines = App.InOutTimelines || {}; 


//console.log(rellocalscrub)
const posts = Array.from(document.querySelectorAll(".carousel-image"));
const postItems = posts.map(post => ({
  post: post,
  lazy: post.querySelector(".lazy"),
  text: post.querySelector(".image-text"),
  texta: post.querySelector(".txani"),
  animationState: {
      slideFade: 'hidden',
      fadeInTween: null,
      fadeOutTween: null,
  }
}));
// console.log(postItems)
const maincont = document.querySelector(".maincont");
App.layout.numImages = postItems.length; 
const unit = 1/App.layout.numImages;
const penult = (App.layout.numImages-1)/App.layout.numImages;
let lastN = 0;
App.progress = { value: startfrom/App.layout.numImages };


const rellocalscrub = Array.from(document.querySelectorAll(".rellocalscrub"));
//const another = Array.from(document.querySelectorAll(".another"));
const nonAnimatedText = postItems.map(item => 
  (item.text && !item.text.classList.contains('txani')) ? item.text : null
);
///////////////////////////////////////////////////////////////////////
// IMPORT AND REGISTER ADDONS
///////////////////////////////////////////////////////////////////////
////// EXTERNAL
import gsap from "gsap" 
import { Observer } from "gsap/Observer"
gsap.registerPlugin(Observer);

////// UTILS
// import '../library_v/utils/lazyload_advnc_hybrid.js'
// Utils Imports
//import { LazyLoadModule } from '../library_v/utils/lazyload_advnc.mod.js'; App.modules.lazyload = LazyLoadModule();
//import { LazyLoadModule } from '../library_v/utils/lazyload_advnc_dec.mod.js'; App.modules.lazyload = LazyLoadModule();
//import { LazyLoadModule } from '../library_v/utils/lazyload_advnc_dec.mod2.js'; App.modules.lazyload = LazyLoadModule(); // works, adds srcset and video poster
//import { LazyLoadModule } from '../library_v/utils/lazyload_advnc_dec.mod3.js'; App.modules.lazyload = LazyLoadModule(); // works, abandons preloading with decoder - no more duplicates on nocache and no more skylines. poster doesnt show up before video though
import { LazyLoadModule } from '../library_v/utils/lazyload_advnc_dec.mod4.js'; App.modules.lazyload = LazyLoadModule(); // same as v3, but abandons the poster totally - no more posters. ali ne radi!
//import { createWaveAnimation } from '../library_v/utils/svgwvs.mod.js'; window.createWaveAnimation = createWaveAnimation; // CALLED FROM WITHIN MODULES
//import { MakeSvgEl } from '../library_v/utils/svgfuns.mod.js'; window.MakeSvgEl = MakeSvgEl; // CALLED FROM WITHIN MODULES

//import { detectDeviceProfile } from "../library_v/utils/deviceprofiler.mod.js";
//const profile = detectDeviceProfile();console.log('device profil: ', profile);
//if (profile.noWebGL) {loadFallbackExperience();return;}// Skip WebGL if unsupported - ako koristis webgl bez three-ja, posto on sam vec radi sve ovo


////// RELATIVE MULTI SCRUB Animation Presets
import { carousel } from '../library_v/presets/relativemultiscrub/carousel.mod.js'; App.RelativeMultiScrub.carousel = carousel;
import { carousel_2 } from '../library_v/presets/relativemultiscrub/carousel_2.mod.js'; App.RelativeMultiScrub.carousel_2 = carousel_2;
// import { alphascaley_1 } from '../library_v/presets/relativemultiscrub/alphascaley_1.mod.js'; App.RelativeMultiScrub.alphascaley_1 = alphascaley_1;

////// GLOBAL SCRUB Animation Presets
// dist 3 (1c6690ec.pixelitious.pages.dev) -> original sa fantasy, regular import; dist 4 (ecaef619.pixelitious.pages.dev) -> original bez fantasy, dist5 (49248eff.pixelitious.pages.dev) -> original sa requestIdle fantasy
// dist6 (76b4036d) -> mod_5, dist7 () -> ugasio controls.update(); i stats;, dist8 () -> stavio gejt; 
//import { FantasyProgressive } from '../library_v/threeprojects/fantasy_progressive.mod_3.js';App.globalscrub.fantasy = FantasyProgressive();
//requestIdleCallback(() => {import('../library_v/threeprojects/fantasy_progressive.mod_6.js').then(({ FantasyProgressive }) => {App.globalscrub.fantasy = FantasyProgressive();});}, { timeout: 2000 });
//requestIdleCallback(() => {import('../library_v/threeprojects/fantasy_progressive.mod_7.js').then(({ FantasyProgressive }) => {App.globalscrub.fantasy = FantasyProgressive();});}, { timeout: 2000 });

//requestIdleCallback(() => {import('../library_v/threeprojects/fantasy_progressive.mod_8.js').then(({ FantasyProgressive }) => {App.globalscrub.fantasy = FantasyProgressive();});}, { timeout: 2000 });

import { FantasyProgressive } from '../library_v/threeprojects/fantasy_progressive.mod_8.js';App.globalscrub.fantasy = FantasyProgressive();

//requestIdleCallback(() => {import('../library_v/threeprojects/fantasy_progressive.mod_5.js').then(({ FantasyProgressive }) => {App.globalscrub.fantasy = FantasyProgressive();});}, { timeout: 2000 });



import { VinnLocation } from '../library_v/presets/globalscrub/vinn_location.mod.js'; App.globalscrub.vinn_location = VinnLocation(); 
import { AlphaScaleyScrub } from '../library_v/presets/globalscrub/AlphaScaleyScrub.mod.js'; App.RelativeMultiScrub.alphascaley_scrub = AlphaScaleyScrub();
//import { Kolazh } from '../library_v/presets/globalscrub/kolazh_1.mod.js'; App.globalscrub.kolazh = Kolazh();
// Navbar
import { Navbar } from '../library_v/navbar/line_chapters_1.mod.js'; App.modules.navbar = Navbar();
//import { CircleChapters } from '../library_v/navbar/circle_chapters_1.mod.js'; App.modules.navbar = CircleChapters();
//import { CirclePlain } from '../library_v/navbar/circle_plain_1.mod.js'; App.modules.navbar = CirclePlain();
//import { LinePlain } from '../library_v/navbar/line_plain_1.mod.js'; App.modules.navbar = LinePlain();

// Loopless Multiscrub: initialize once, then drive inside global scrub with no looping
const textElements = postItems.map(item => item.text); // Get all text elements
App.RelativeMultiScrub.alphascaley_scrub.init(textElements, App.layout.numImages);

////// TRIGGERED Animation Presets
import { Alphay1 } from '../library_v/presets/triggeredanimations/alphay_1.mod.js'; App.TriggeredAnimations.Alphay1 = Alphay1;
import { ClassicOpacity } from '../library_v/presets/triggeredanimations/classic_opacity.mod.js'; App.InOutTimelines.classic_opacity = ClassicOpacity;// In/Out Timeline Presets - trenutno ti treba da bi radio narator,ISPRAVI!
import { Narrator } from '../library_v/presets/triggeredanimations/narrator.mod.js'; App.TriggeredAnimations.narrator = Narrator;
//import { Narrator } from '../library_v/presets/triggeredanimations/narratori.mod.js'; App.TriggeredAnimations.narrator = Narrator; // now independent of classicopacity or any other code that sets up animationState - if none does - narratori builds it

///// STATS
// import { Stresstest } from '../library_v/stats/stresstest_1.mod.js'; App.modules.strestest = Stresstest(); // REMOVE IN PRODUCTION

///////////////////////////////////////////////////////////////////////
// APP INITIALIZATION
///////////////////////////////////////////////////////////////////////
function initApp() {
///////////////////////////////////////////////////////////////////////
// --- 1. CONFIGURATION --- SET AND REMOVE IN PRODUCTION?
///////////////////////////////////////////////////////////////////////

// CONFIGURE THE MASTER 
const config = {
  direction: {
    slidestack:1,
    drag: -1,
    mouseWheel: 1,
    touchpad: 1,
    lineProgress: 1,
  },
  sensitivity: {
//    drag: 0.001,
    drag: 0.0005,
//    flick: 0.005,
//    flick: 0.002,
    flick: 0.0007,
//    mouseWheel: 0.005,
    mouseWheel: 0.003,
//    mouseWheel: 0.002,
//    mouseWheel: 2.5/(100*App.layout.numImages),
//    mouseWheel: Math.round(25/(App.layout.numImages))/1000,
    touchpad: 0.001
  },
  behavior: {
//    loopMode: "infinite", // Options: "infinite", "bounded", "intro"
    loopMode: "introf", // Options: "infinite", "bounded", "intro", "introf"
//    maxSlidesPerScroll: Infinity, // Default: No limit. Set to 1 for "one-by-one".
//    snapThreshold: 0.05, // 5% movement is enough to trigger a slide change (anti-bounce)
    obsdur: 2 // 5% movement is enough to trigger a slide change (anti-bounce)
	},
  triggeredAnimations: {
    slideFade: {
      duration: 0.6,
      easeIn: "power2.out",
      easeOut: "power2.in",
      entry_p: 0.2,
      exit_p: 0.2
    },
    textFade: {
      duration: 0.5,
      easeIn: "power1.out",
      easeOut: "power1.in",
      entry_p: 0.3,
      exit_p: 0.3
    }
  }
};
//console.log(config.sensitivity.mouseWheel)
// CONFIGURE THE ADDONS
// [NOTE] This works perfectly because we instantiated App.globalscrub.vinn_location ABOVE initApp()
    if (App.globalscrub && App.globalscrub.vinn_location) {
//  console.log('existis');
//    App.globalscrub.vinn_location.config.direction.lineProgress = -1; // Change direction
   }

if (App.modules.lazyload) {
let bidir = true;
if (config.behavior.loopMode !== "infinite") bidir = false;
App.modules.lazyload.setConfig({
  lazyClass: ".lazy",
  lookahead: 2,
  lookbehind: 1,                          // how many slides behind to preload (if bidirectional)
//  bidirectional: true,
  bidirectional: bidir,
  removeDataAttr: true,
//  fadeInClass: "lazy-fadein",
  fadeInClass: "showlazy",
  preconnectOrigins: ["https://example-cdn.com"]
});
;}

    if (App.InOutTimelines && App.InOutTimelines.classic_opacity) {
//    App.InOutTimelines.classic_opacity.config.duration = 2; // Change duration
   }
   
   App.modules.lazyload.config.loadDelay = (config.triggeredAnimations.slideFade.duration*1.6)*1000;
   
if (App.modules?.navbar) {if(config.behavior.loopMode !== "infinite")App.modules.navbar.config.chapters.dir="bounded"} // REQUIRED whenever you have navbar
///////////////////////////////////////////////////////////////////////
// --- 1.3. DRIVERS ---
///////////////////////////////////////////////////////////////////////
// Setup Module Drivers: REMOVE IN PRODUCTION
function addons_start() {if (App.modules.stats) App.modules.stats.begin();}// REMOVE IN PRODUCTION

// REMOVE IN PRODUCTION: all the if statements in the drivers
////// GLOBAL SCRUB Animation Drivers
let lastProcessedProgress = -1;
function addons_end() {
const currentProgress = App.progress.value;
if (Math.abs(currentProgress - lastProcessedProgress) > 0.0001) {

  if (App.modules?.navbar) App.modules.navbar.updateLineProgress(App.progress.value);// DONE =? are we setting up these animations 60fps over and over though??
  if (App.globalscrub?.vinn_location) App.globalscrub.vinn_location.updateLineProgress(App.progress.value); // DONE
  
  if (App.modules?.addon2) App.modules.addon2.main();
  if (App.globalscrub?.kolazh) App.globalscrub.kolazh.updateLineProgress(App.progress.value);
  
  if (App.globalscrub?.fantasy) { // DONE
      let linePercent = (App.progress.value % 1 + 1) % 1;   
      // Update Airship and Camera
      App.globalscrub.fantasy.updateAirship(linePercent); App.globalscrub.fantasy.scrubCamera(linePercent);
    }
	
	if (App.RelativeMultiScrub?.alphascaley_scrub) App.RelativeMultiScrub.alphascaley_scrub.updateProgress(App.progress.value);
	
	if (App.modules?.strestest) App.modules.strestest.stresstest();// REMOVE IN PRODUCTION
	if (App.modules?.stats) App.modules.stats.end();  // REMOVE IN PRODUCTION
	
	}
}

////// CUSTOM TRIGGERED Animation Drivers (relying on current or last N)
function triggered_custom(currentN, lastN) {
if (App.modules.lazyload) {App.modules.lazyload.process(currentN, lastN);}
}

////// RELATIVE MULTI SCRUB Animations Drivers. NOTE: remove these if statements when done, no need to do this Nx60fps inside animate()!
const radius = 242;
const rms_anim_driver = function(item, index) {
if (Math.abs(App.progress.value - lastProcessedProgress) < 0.0001) return;
  if (App.RelativeMultiScrub?.carousel_2) App.RelativeMultiScrub.carousel_2(rellocalscrub[index], index, radius, App.progress.value, App.layout.numImages); // DONE
  // App.RelativeMultiScrub.carousel_2(another[index], index, 2*radius, App.progress.value, App.layout.numImages); // you may use multiples like this
  if (App.RelativeMultiScrub?.carousel) App.RelativeMultiScrub.carousel(item.post, index, radius, App.progress.value, App.layout.numImages); // DONE
  //App.RelativeMultiScrub.carousel([item.post], index, [radius, radius]);
//  const c = Math.floor(index / App.layout.numImages * 360); item.post.style.background = `hsla(${c}, 100%, 60%, .9)`;
  //if (App.RelativeMultiScrub?.alphascaley_1) App.RelativeMultiScrub.alphascaley_1(nonAnimatedText[index], index, App.progress.value, App.layout.numImages); // DONE, but more efficient using global scrub

};

////// SETUP TIMELINES AND TRIGGERED ANIMATIONS ---
///////////////////////////////////////////////////////////////////////
function setupAnimations() {
  const slideFadeConfig = config.triggeredAnimations.slideFade;
  postItems.forEach((item, index) => {
    // 1. Initial State Flag - state flag prevents triggered animations from firing at 60fps, you only need one general one tied to the main slide fade in/out timelines
    item.animationState.slideFade = index === 0 ? 'visible' : 'hidden'; // needed for triggered animations only i think
	
	if (App.InOutTimelines?.classic_opacity) App.InOutTimelines.classic_opacity(item, index, item.texta); // Fade-IN Fade-OUT TIMELINE applied to a specific sub element of the slide
	if (App.TriggeredAnimations?.narrator) App.TriggeredAnimations.narrator(item, index, item.texta); // Sound Text Fade Tweens
	if (App.TriggeredAnimations?.Alphay1) App.TriggeredAnimations.Alphay1(item, index, ".my-custom-text"); // Custom Fade Tweens
  });
  lastN = 0; // Initialize lastN to the starting slide index
}

// Load NARATOR TRACK - narrator radi i bez ovoga, samo bez zvuka!
// Old (Vite ignores it)
// App.sound.nartrack = new Audio('./assets/audio/Vinn.mp3');

// NEW (Vite sees "new URL", bundles the file, hashes it, and returns the new path)
App.sound.nartrack = new Audio(new URL('./assets/audio/Vinn.mp3', import.meta.url).href);
App.sound.nartrack.isplayin = false;
App.sound.nartrack.onplaying = function() {App.sound.nartrack.isplayin = true;};
App.sound.nartrack.onpause = function() {App.sound.nartrack.isplayin = false;};
App.sound.soundon = false;
// Load MAIN BG TRACK
//App.sound.main = new Audio('./assets/audio/water.mp3'); 
App.sound.main = new Audio(new URL('./assets/audio/water.mp3', import.meta.url).href);

App.sound.main.loop = true;


///////////////////////////////////////////////////////////////////////
// --- 2. ENGINE ---
///////////////////////////////////////////////////////////////////////
// CONTROL PROGRESS
// Global state for the "intro" logic
let introLockReleased = false;

function validateProgress(targetValue) {
  const mode = config.behavior.loopMode;

  // 1. INFINITE: Do nothing, let it flow negative or positive
  if (mode === "infinite") return targetValue;

  // 2. BOUNDED: Strict wall at start (0) and end (1)
  // We subtract a tiny epsilon (0.0001) from 1 to prevent it from wrapping back to 0 visually
  if (mode === "bounded") {
//    return gsap.utils.clamp(0, 0.9999, targetValue); 
    return gsap.utils.clamp(0, penult, targetValue); 
  }

  // 3. INTRO: Block going back from 0 initially, but unlock once we move at least 1 slide forward
  if (mode === "intro") {
    if (!introLockReleased) {
      if (targetValue < 0) return 0; // Block backward
      if (targetValue >= unit) {introLockReleased = true; if (App.modules?.navbar) App.modules.navbar.config.chapters.dir="shortest"; } // Unlock if moved forward and reset the navbar from bounded to allow shortest path
    }
    return targetValue; // Once unlocked, acts like infinite
  }
  
  // 4. INTROF: Intro full - Block going back from 0 initially, but unlock once we make one full circle
  if (mode === "introf") {
    if (!introLockReleased) {
      if (targetValue < 0) return 0; // Block backward
      if (App.progress.value >= penult) {introLockReleased = true; if (App.modules?.navbar) App.modules.navbar.config.chapters.dir="shortest"; } // Unlock if moved forward and reset the navbar from bounded to allow shortest path
    }
    return targetValue; // Once unlocked, acts like infinite
  }

  return targetValue;
}



///////////////////////////////////////////////////////////////////////
// --- 2.1. SETUP OBSERVER LOGIC  ---
///////////////////////////////////////////////////////////////////////
const snap = gsap.utils.snap(1 / App.layout.numImages);
Observer.create({
  target: maincont,
  type: "wheel,pointer",
  dragMinimum: 10,
  onPress: self => {
    gsap.killTweensOf(App.progress);
    maincont.style.cursor = "grabbing";
  },
  onRelease: self => {
    maincont.style.cursor = "grab";
  },
  onDrag: self => {
   if (Math.abs(self.deltaY) > Math.abs(self.deltaX) * 1.5) {
//    const velocityFactor = config.sensitivity.flick * config.direction.drag;
//    const velocity = self.velocityX * velocityFactor;
//	console.log('ondrag');
	const absY = Math.abs(self.deltaY);
	const dir = self.deltaY > 0 ? -1 : 1;
	const reward = absY * 0.003;
    const p = Math.min(Math.max(reward, 0.09), 0.4) * config.direction.touchpad * dir;
	const rawTargetProgress = App.progress.value + p;
	
//    const rawTargetProgress = App.progress.value + velocity;
    const validTarget = validateProgress(rawTargetProgress);
    const finalProgress = snap(validTarget);
    // The control tween
    gsap.to(App.progress, { 
      duration: config.behavior.obsdur, 
      ease: "power4.out", 
      value: finalProgress
    });
	}
  },
  onWheel: self => {
    gsap.killTweensOf(App.progress);
    const isHorizontalSwipe = Math.abs(self.deltaX) > Math.abs(self.deltaY);
    let p = isHorizontalSwipe
      ? self.deltaX * config.sensitivity.touchpad * config.direction.touchpad
      : self.deltaY * config.sensitivity.mouseWheel * config.direction.mouseWheel;  
    const rawTargetProgress = App.progress.value + p;
    const validTarget = validateProgress(rawTargetProgress);
    let finalProgress = snap(validTarget);
//	console.log('onwheel',self.deltaX,self.deltaY);
    // The control tween
    gsap.to(App.progress, { 
      duration: 2, 
      ease: "power4.out", 
      value: finalProgress 
    });
  }
});




// KEYBOARD NAVIGATION
window.addEventListener("keydown", event => {
    // 1. Filter Keys
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;

    // 2. Kill ongoing scrolls to prevent fighting
    gsap.killTweensOf(App.progress);

    // 3. Determine Direction (Right = Next/Plus, Left = Prev/Minus)
    const direction = event.key === "ArrowRight" ? 1 : -1;
    const unit = 1 / App.layout.numImages;

    // 4. Calculate Target
    // We snap the CURRENT position first to ensure we step cleanly from a valid slide
    const currentSnapped = snap(App.progress.value);
    const rawTarget = currentSnapped + (direction * unit);

    // 5. Validate (Apply Intro/Loop/Bounded rules)
    // We skip 'applyPhysicsConstraints' because a Key Press is an explicit intent 
    // to move 1 slide, so we don't need threshold/velocity checks.
    const finalTarget = validateProgress(rawTarget);

    // 6. Animate
    gsap.to(App.progress, {
        duration: 1.5, // Keys feel better with slightly snappier timing than drag
        ease: "power4.out",
        value: finalTarget
    });
});
///////////////////////////////////////////////////////////////////////
// --- 2.2. MAIN ANIMATION LOOP ---
///////////////////////////////////////////////////////////////////////
const animate = () => {
  addons_start();// REMOVE IN PRODUCTION
  
  const currentProgress = App.progress.value;
  const hasMoved = Math.abs(currentProgress - lastProcessedProgress) > 0.0001;
//  if (hasMoved) {
  // --- A. Calculate Current State ---
  const progressIndex = App.progress.value * App.layout.numImages;
  const currentN_int = Math.round(progressIndex);
  const currentN = gsap.utils.wrap(0, App.layout.numImages)(currentN_int);
  // --- B. Trigger Animations (Smart N) ---
  if (currentN !== lastN) {
    const lastItem = postItems[lastN];
    const currentItem = postItems[currentN];
    // Fade out old slide if it wasn't already hidden
    if (lastItem && lastItem.animationState.slideFade !== 'hidden') {
      lastItem.animationState.fadeOutTween?.invalidate().restart(); // Use restart() for clean play from start
      lastItem.animationState.slideFade = 'hidden';
    }
    // Fade in new slide if it wasn't already visible
    if (currentItem && currentItem.animationState.slideFade !== 'visible') {
      currentItem.animationState.fadeInTween?.invalidate().restart();
      currentItem.animationState.slideFade = 'visible';
    }
    triggered_custom();
    lastN = currentN;
  }
  
  // Relative Multi-scrub Animations, like Animate Carousel Items (Rotation Scrub)
  postItems.forEach((item, index) => {
    rms_anim_driver(item, index);
  }); 
  // Global Scrub Animations, like vinn_location animation, or any kind of progress update animation
  addons_end();
//  lastProcessedProgress = currentProgress;
//  }
};
///////////////////////////////////////////////////////////////////////
// --- 2.3. CALLS ---
///////////////////////////////////////////////////////////////////////
gsap.delayedCall(0, () => {setupAnimations();});// Call gsap animation initializations
gsap.ticker.add(animate);// --- Add animate function to GSAP's ticker ---


//////// LOAD FADE INs 
const nav = document.querySelector('.skrj');

function showNav() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      nav.classList.add('showlazy');
    });
  });
}

// after your svg parsing/layout work finishes:
// showNav();
//  window.addEventListener('load', () => {
  window.addEventListener('DOMContentLoaded', () => {

      const preloader = document.getElementById('preloader-layer');
      if(preloader) {
          preloader.style.opacity = 0;
          setTimeout(() => preloader.remove(), 500);
      }
  });
  
  
  
// Pseudo-code
//window.addEventListener('scroll', () => {if (!loaded) { injectAnalytics(); loaded = true; }}, { once: true });


  

//console.log("App started");
//console.log("%c█ BUILT BY PIXELITIOUS █\n%chttps://yourstudio.com","font-family: monospace; font-size:13px; font-weight:700; padding:4px 8px; background:#000; color:#00f5ff; text-shadow: 0 0 3px #00f5ff, 1px 1px 0 #ff3d81, -1px -1px 0 #7cff00; border:1px solid #00f5ff;","font-family: monospace; font-size:11px; color:#bbb;");
//console.log("%cBUILT BY\n%cPIXELITIOUS\n%chttps://yourstudio.com","font-family: monospace; font-size:11px; letter-spacing:2px; color:#ffb000;","font-family: monospace; font-size:14px; font-weight:400; letter-spacing:1px; color:#00ffd5; text-shadow: 1px 1px 0 #ff006a;","font-family: monospace; font-size:10px; color:#888;");
//console.log(`%c■ ■ ■   YOUR STUDIO   ■ ■ ■%c   ▒ Built by: Your Name%c■   ■    💠💠💠    ■   ■%c  ■   ■            ■   ■%c■   ■    💠💠💠    ■   ■`,"color:#00f5ff; font-weight:900; font-size:18px; letter-spacing:2px;","color:#888; font-size:12px; letter-spacing:1px;","color:#ff2be6;","color:#ffd900;","color:#24ff24;");
console.log(
  "%cBUILT BY\n%cPIXELITIOUS %c■ %c■ %c■\n%chttps://yourstudio.com",
  "font-family:monospace;font-size:11px;letter-spacing:2px;color:#ffb000;",
  "font-family:monospace;font-size:14px;font-weight:400;letter-spacing:1px;color:#00ffd5;text-shadow:1px 1px 0 #ff006a;",
  "font-family:monospace;font-size:12px;color:#ff2be6;",
  "font-family:monospace;font-size:10px;color:#00ff66;",
  "font-family:monospace;font-size:8px;color:#0088ff;",
  "font-family:monospace;font-size:10px;color:#777;"
);
//console.log("%cBUILT BY\n%cSTUDIO\n%c   ■\n%c     ■\n%c       ■\n%chttps://yourstudio.com","font-family:monospace;font-size:11px;color:#ffb000;","font-family:monospace;font-size:14px;color:#00ffd5;","font-family:monospace;font-size:12px;color:#ff2be6;","font-family:monospace;font-size:10px;color:#00ff66;","font-family:monospace;font-size:8px;color:#0088ff;","font-family:monospace;font-size:10px;color:#777;");


}

initApp();
//const nvbr = document.querySelector(".progress-bars-container");nvbr?.classList.remove('hide');console.log(nvbr)
// REMOVE IN PRODUCTION
const printstuff = 0;
if (printstuff){
// This is what i use for debugging to see whats loaded
if (App.modules.navbar) {console.log("Navbar app detected:", App.modules.navbar.config);} else{console.log("Navbar addon not in this app");}
if (App.modules.strestest) {console.log("Stress test app detected:", App.modules.strestest.config);} else{console.log("Stress test addon not in this app");}
if (App.modules.stats) {console.log("Stats app detected");} else{console.log("Stats addon not in this app");}
if (App.InOutTimelines) {console.log("FadeIn FadeOut Timeline Preset Loaded: ",App.InOutTimelines);} else{console.log("No timeline preset loaded");}
if (App.TriggeredAnimations) {console.log("Triggered Animation Presets Loaded: ",App.TriggeredAnimations);} else{console.log("No triggered animations preset loaded");}
if (App.RelativeMultiScrub) {console.log("Relative Multi-scrub Animation Presets Loaded: ",App.RelativeMultiScrub);} else{console.log("No Relative Multi-scrub animations preset loaded");}
if (App.globalscrub) {console.log("Global Scrub Animation Presets Loaded: ",App.globalscrub);} else{console.log("No global scrub animations preset loaded");}
if (App.modules.lazyload) {console.log("Lazy Load Functionality Loaded, config: ",App.modules.lazyload.cfg);} else{console.log("No Lazy Load Functionality Loaded");}
}

  // 3. Remove Preloader (Simulated)

